import React, { CSSProperties } from 'react'
import { SvgIcon, SvgIconProps } from '@hermes/web-components'

type SearchIconProps = SvgIconProps & CSSProperties

const SearchIcon = ({ ...props }: SearchIconProps) => (
  <SvgIcon width="22" height="22" viewBox="0 0 22 22" {...props}>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.03431 16.6642C13.2903 16.6642 16.7405 13.3783 16.7405 9.32494C16.7405 5.2716 13.2903 1.98572 9.03431 1.98572C4.7783 1.98572 1.32812 5.2716 1.32812 9.32494C1.32812 13.3783 4.7783 16.6642 9.03431 16.6642Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6313 20.3699L14.4766 14.5082"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
)

export default SearchIcon
